import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'

const NumbersStatus = () => {

    const STATUS = { STARTED: 'Traitement en cours...', }
    
      const INITIAL_COUNT1 = 300
    
      const [secondsRemaining1,            setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
      const [status1,                      setStatus1           ] = useState(STATUS.STOPPED)
    
      useEffect(()=>{
        setStatus1(STATUS.STARTED)
      },[STATUS.STARTED])
  
    useInterval(
      () => {
      if (secondsRemaining1 > 0) {
          setSecondsRemaining1(secondsRemaining1 - 1)
      } else {
          setStatus1(STATUS.STOPPED)
      }
      },
  
      status1 === STATUS.STARTED ? 1000 : null,
      // passing null stops the interval
  )
  
  function useInterval(callback, delay) {
      const savedCallback = useRef()
  
      // Remember the latest callback.
      useEffect(() => {
      savedCallback.current = callback
      }, [callback])
  
  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
  }
  
  var [themeMode, setThemeMode] = useState()
  
  let ThemeMode = localStorage.getItem("ThemeMode")
  
  useEffect(()=>{
    
    if(secondsRemaining1 > 0){
      setThemeMode(ThemeMode)
    }
  
  },[ThemeMode, secondsRemaining1])

  const [GetUser, setGetUser] = useState([])
  const [UserFounded, setUserFounded] = useState(false)
  const [Operation, setOperation] = useState([])
  const [StopOperation, setStopOperation] = useState(false)
  const [ownWitness, setOwnWitness] = useState([])
  const [ownWitnessStopReq, setOwnWitnessStopReq] = useState(false)


  useEffect(() => {
    if(!UserFounded){
      if(secondsRemaining1 > 0){
        const fetchDada12 = async () => {
          try {
            const { data } = await axios.get(
              '/api/v1/get-users'
            )
            if(data.length > 0){
              setGetUser(data)
              if(GetUser.length > 0){
                setUserFounded(true)
              }
            }
          } catch (error) { }
        }
        fetchDada12()
      }
    }

  }, [secondsRemaining1, GetUser, UserFounded])
  
  useEffect(() => {

    const fetchData = async () => {

      if(!StopOperation){
        try {
          const { data } = await axios.get(
            '/api/v1/operations',
          )
          if(data.length > 0){
            setOperation(data)
            setStopOperation(true)
          }
          
        } catch (error) {}
      }
    }

    fetchData()

  }, [Operation, StopOperation])
    
  useEffect(()=>{

    const fetchWitnessDada = async () => {
      if(!ownWitnessStopReq){
          try {
            const { data } = await axios.get(
              '/api/v1/get-witnesses',
            )
            setOwnWitness(data)
          } catch (error) {}
      }
    }

    fetchWitnessDada()

  },[ownWitness, ownWitnessStopReq])


  return (
    
    <div className='row mt-5 mb-5'>

    <div className='col-md-4'>
      <h1 className="header__title" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Membres actifs</h1>
      <p className='nkab-card'><h4 style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>{GetUser.length === 0 ? <div className='text-center'><div className="nkab-spinner"></div></div> : <strong>{GetUser.length}+</strong>}</h4></p>
    </div>

    <div className='col-md-4'>
      <h1 className="header__title" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Opérations effectuées</h1>
      <p className='nkab-card'><h4 style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>{Operation.length === 0 ? <div className='text-center'><div className="nkab-spinner"></div></div> : <strong>{Operation.length}+</strong>}</h4></p>
    </div>

    <div className='col-md-4'>
      <h1 className="header__title" style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>Commentaires</h1>
      <p className='nkab-card'><h4 style={{color:`${themeMode === "true" ? "#90d9ff" : "#333"}`}}>{ownWitness.length === 0 ? <div className='text-center'><div className="nkab-spinner"></div></div> : <strong>{ownWitness.length}+</strong>}</h4></p>
    </div>

  </div>

  )
}

export default NumbersStatus